import {toast, ToggleButton} from '@wandb/components';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {useDispatch} from '../../../state/hooks';
import * as ViewThunks from '../../../state/views/thunks';
import type {NamedWorkspaceMenuItem} from '../types';

type NamedWorkspacePinButtonProps = {
  option: NamedWorkspaceMenuItem;
};

export const NamedWorkspacePinButton = ({
  option,
}: NamedWorkspacePinButtonProps) => {
  const dispatch = useDispatch();

  const togglePin = async () => {
    const succeeded = await dispatch(
      option.starred
        ? ViewThunks.unstarView(option.viewRef)
        : ViewThunks.starView(option.viewRef)
    );
    if (!succeeded) {
      toast.error('Failed to update pin.');
    }
  };

  return (
    <span
      className={twMerge(
        'ml-auto shrink-0 self-center',
        !option.starred &&
          'invisible group-hover:visible group-focus-within:visible'
      )}>
      <ToggleButton
        variant="pin"
        isSelected={option.starred}
        size="sm"
        aria-label={`${option.starred ? 'Unpin' : 'Pin'} view ${option.displayName}`}
        data-test={
          option.starred ? 'workspace-pin-filled' : 'workspace-pin-empty'
        }
        isDisabled={option.starLoading}
        onPress={togglePin}
        tooltip={{children: `${option.starred ? 'Unpin' : 'Pin'} view`}}
      />
    </span>
  );
};
